import { useState } from "react";
import { Marca } from "@notes/ui";
import { Onda } from "./Onda.js";

/**
 * Segunda etapa do login. A sessão restrita chega até aqui e não passa daqui.
 *
 * "Confiar neste dispositivo" existe para o segundo fator não virar pedágio
 * diário no computador de trabalho, que é o que faz gente desligar a proteção.
 */
export function Desafio({ aoEntrar }: { aoEntrar: () => void }) {
  const [codigo, setCodigo] = useState("");
  const [lembrar, setLembrar] = useState(true);
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  const enviar = async (e: React.FormEvent) => {
    e.preventDefault();
    setErro(null); setEnviando(true);
    try {
      const r = await fetch("/auth/2fa/desafio", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ codigo, lembrarDispositivo: lembrar }),
      });
      if (!r.ok) {
        const corpo = await r.json().catch(() => ({})) as { erro?: string };
        setErro(corpo.erro ?? "Código não confere.");
        return;
      }
      aoEntrar();
    } catch { setErro("Não consegui falar com o servidor."); }
    finally { setEnviando(false); }
  };

  const sair = async () => { await fetch("/auth/sair", { method: "POST" }); location.reload(); };

  return (
    <div className="enotes enotes-entrada">
      <aside className="enotes-entrada-arte" aria-hidden="true">
        <div className="enotes-entrada-grade" />
        <Onda />
      </aside>
      <main className="enotes-entrada-form">
        <div className="enotes-entrada-caixa surge">
          <Marca tamanho={32} />
          <form onSubmit={enviar} className="mt-8">
            <p className="eyebrow">Verificação</p>
            <h1 className="titulo-pagina mt-2">Confirme que é você</h1>
            <p className="mt-1.5 text-sm" style={{ color: "var(--muted-foreground)" }}>
              Abra o aplicativo de autenticação e informe o código de seis dígitos.
              Se estiver sem o celular, use um dos códigos de recuperação.
            </p>
            <div className="mt-6">
              <label className="block">
                <span className="eyebrow block pb-1.5">Código</span>
                <input className="campo num" value={codigo} inputMode="numeric" autoFocus
                  autoComplete="one-time-code" onChange={(ev) => setCodigo(ev.target.value)}
                  aria-label="Código de verificação" required />
              </label>
              <label className="enotes-marcar">
                <input type="checkbox" checked={lembrar} onChange={(e) => setLembrar(e.target.checked)} />
                <span>Confiar neste dispositivo</span>
              </label>
            </div>
            {erro && (
              <p role="alert" className="enotes-erro">
                <span aria-hidden className="sinal sinal-critico" /><span>{erro}</span>
              </p>
            )}
            <button className="botao mt-6 w-full" data-variante="primario" disabled={enviando}>
              {enviando ? "Verificando" : "Continuar"}
            </button>
            <button type="button" className="enotes-linha-link mt-4" onClick={() => void sair()}>
              entrar com outra conta
            </button>
          </form>
        </div>
        <p className="enotes-entrada-rodape carimbo">EnturOS · Notes</p>
      </main>
    </div>
  );
}
